<template>
  <div>
    <b-row>
      <div class="border border-primary rounded-lg mt-2">
        <b-col md="12">
          <h3 class="mt-1">
            {{ clueList.clueCode }}
          </h3>

          <TabAttachFiles
            @handle-upload="onAttachFileUploaded"
            @handle-delete="onAttachFileDelete"
            :attachFiles="clueList.attachFiles"
            :keyId="clueList.clueId"
          />
        </b-col>
      </div>
    </b-row>
    <b-row>
      <b-col cols="6" class="d-flex justify-content-start mt-2">
        <b-button variant="secondary" @click="onBackBtnClicked">
          ย้อนกลับ
        </b-button>
      </b-col>
      <b-col cols="6" class="d-flex justify-content-end mt-2">
        <b-button variant="primary" @click="onSubmitBtnClicked">
          ยืนยัน
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BButton } from "bootstrap-vue";
import * as clueStore from "@/store/api/clue/index.js";
import TabAttachFiles from "./service/TabClueAttachFiles.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    clueStore,
    TabAttachFiles,
  },
  data() {
    return {
      clueList: [],
      attachFiles: [],
      parentComponent: "",
    };
  },
  beforeMount() {
    var self = this;

    clueStore
      .getById(
        self.$route.query.clueId
        //,self.$route.query.isGroupGuid
      )
      .then(function(response) {
        self.clueList = response.data.data;
        self.attachFiles = response.data.data.attachFiles;
      })
      .catch(function(error) {
        console.log("error", error);
      })
      .then(function() {});

    this.parentComponent = this.$route.query.parentComponent;
  },
  methods: {
    onAttachFileUploaded(file) {
      this.attachFiles.push(file);
    },
    onAttachFileDelete(id) {
      const file = this.attachFiles.find(function(value) {
        return value.attachId === id;
      });

      var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

      this.attachFiles = filteredAry;
    },
    onBackBtnClicked() {
      if (
        this.parentComponent !== null &&
        this.parentComponent !== undefined &&
        this.parentComponent !== ""
      ) {
        console.log("this.parentComponent !== null", this.parentComponent);
        this.$router.push({ name: this.parentComponent });
      } else {
        this.$router.push({ name: "dashboard-ecommerce" });
      }
    },
    onSubmitBtnClicked() {
      this.$router.push({ name: this.parentComponent });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
